/**
 * Build videoxx.php base URL from the current API line URL.
 * api. / api1. / api2. → {phpPrefix}. / {phpPrefix}1. / {phpPrefix}2.
 */
export function buildVideoPhpBase(apiBase: string, phpPrefix: string): string {
    const prefix = phpPrefix || 'xxapi'
    return apiBase
        .replace(/\/$/, '')
        .replace(/^(https?:\/\/)api(\d*)\./i, `$1${prefix}$2.`)
}
